// src/components/LoyaltyStreak.js
// Shows how long the member has been subscribed and their milestone rewards
import { useMemo } from 'react'
import './LoyaltyStreak.css'

const MILESTONES = [
  { days: 7,   label: '1 Week',   reward: 'Exclusive wallpaper unlocked',        icon: '✦' },
  { days: 30,  label: '1 Month',  reward: 'Personal voice note from Sky Bri',     icon: '🌹' },
  { days: 90,  label: '3 Months', reward: 'One free tier upgrade for a month',    icon: '◈' },
  { days: 180, label: '6 Months', reward: 'VIP dinner priority booking',          icon: '★' },
  { days: 365, label: '1 Year',   reward: 'Lifetime Platinum status — permanent', icon: '♛' },
]

export default function LoyaltyStreak({ profile }) {
  const createdAt = profile?.created_at
  const name = profile?.display_name || 'Member'

  const stats = useMemo(() => {
    if (!createdAt) return { days: 0, nextMilestone: MILESTONES[0], progress: 0 }
    const days = Math.floor((Date.now() - new Date(createdAt).getTime()) / 86400000)
    const reached = MILESTONES.filter(m => days >= m.days)
    const next = MILESTONES.find(m => days < m.days) || null
    const prev = reached[reached.length - 1] || { days: 0 }
    const progress = next
      ? Math.min(100, ((days - prev.days) / (next.days - prev.days)) * 100)
      : 100
    return { days, reached, next, progress }
  }, [createdAt])

  return (
    <div className="streak">
      <div className="streak__header">
        <div>
          <p className="streak__eyebrow">Member Loyalty</p>
          <h3 className="streak__title">
            <span className="streak__days">{stats.days}</span>
            <span className="streak__days-label">days</span>
            in the circle
          </h3>
        </div>
        <div className="streak__fire">
          {stats.days >= 365 ? '♛' : stats.days >= 90 ? '◈' : '✦'}
        </div>
      </div>

      {/* PROGRESS TO NEXT MILESTONE */}
      {stats.next && (
        <div className="streak__progress-wrap">
          <div className="streak__progress-header">
            <span className="streak__progress-label">
              Next: {stats.next.label} — {stats.next.reward}
            </span>
            <span className="streak__progress-days">
              {stats.next.days - stats.days} days to go
            </span>
          </div>
          <div className="streak__bar">
            <div
              className="streak__bar-fill"
              style={{ width: `${stats.progress}%` }}
            />
          </div>
        </div>
      )}

      {/* MILESTONES */}
      <div className="streak__milestones">
        {MILESTONES.map(m => {
          const reached = stats.days >= m.days
          return (
            <div key={m.days} className={`streak-milestone ${reached ? 'streak-milestone--reached' : 'streak-milestone--locked'}`}>
              <div className="streak-milestone__icon">{m.icon}</div>
              <div className="streak-milestone__info">
                <p className="streak-milestone__label">{m.label}</p>
                <p className="streak-milestone__reward">{m.reward}</p>
              </div>
              <div className={`streak-milestone__badge ${reached ? 'streak-milestone__badge--done' : ''}`}>
                {reached ? 'Earned' : `${m.days}d`}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
